module.exports = __webpack_public_path__ + "img/de_Ecran 1.ccb54e45.png";